module.exports = __webpack_public_path__ + "media/images/riders/small/AARON_GWIN-9ba05d5e415adee930fa7b4ad9577791.png";